import {buildUpdateRequest} from '../../config/redux-list/requests';
import {FORM_RESPONSE_COLLECTION} from '../domain/config';
import {getUpdateSingleFormResponse} from '../reducers/state';
import {logger} from './logger';
import {UPDATE_SINGLE_FORM_RESPONSE_PREFIX} from './state';


export const updateSingleResponseReduxRequest = buildUpdateRequest({
  prefix: UPDATE_SINGLE_FORM_RESPONSE_PREFIX,
  getState: getUpdateSingleFormResponse,
  path: FORM_RESPONSE_COLLECTION,
  logger,
});



// WEBPACK FOOTER //
// ./src/js/forms/redux/updateSingleResponse.js